import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
import NotFound410Exception from "@/exceptions/NotFound410Exception";
import Redirection301Exception from "@/exceptions/Redirection301Exception";
export var api__getPostDetailByID = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(postId) {
    var _res$data;
    var include, params, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (postId) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", null);
        case 2:
          include = "details";
          params = {
            id: postId,
            thumb_size: 300,
            device_type: 'web',
            should_redirect: 0,
            include: include
          };
          _context.next = 6;
          return fetcher().get("/post/view-online", {
            params: params
          });
        case 6:
          res = _context.sent;
          return _context.abrupt("return", (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || null);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function api__getPostDetailByID(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var api__getCarPriceDetails = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(req, postId) {
    var _res$data2;
    var include, params, res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (postId) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", null);
        case 2:
          include = "price";
          params = {
            id: postId,
            device_type: 'web',
            include: include
          };
          _context2.next = 6;
          return fetcher(req).get("/post/view-online", {
            params: params
          });
        case 6:
          res = _context2.sent;
          return _context2.abrupt("return", (res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data.price) || null);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function api__getCarPriceDetails(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var api__getNewPostViewData = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(postId) {
    var _res$data3, _res$data4;
    var req,
      include,
      params,
      res,
      post,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          req = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : null;
          include = "details,price,story,quality,meta,analytics,campaign,g4Data,options,featuredImage,gallery_section,gallery,fuel,faqs,footerdetails,footer";
          params = {
            id: postId,
            thumb_size: 300,
            device_type: 'web',
            should_redirect: 1,
            include: include
          };
          _context3.next = 5;
          return fetcher(req).get("/post/view-online", {
            params: params
          });
        case 5:
          res = _context3.sent;
          if (!((res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.code) === 230)) {
            _context3.next = 11;
            break;
          }
          if (!__IS_CSR__) {
            _context3.next = 10;
            break;
          }
          window.location.href = "?ref=post-404";
          return _context3.abrupt("return", null);
        case 10:
          throw new NotFound410Exception(postId, 'api__getNewPostViewData code 230');
        case 11:
          post = (res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.data) || null;
          if (post) {
            _context3.next = 14;
            break;
          }
          return _context3.abrupt("return", null);
        case 14:
          if (!post.fallback_url) {
            _context3.next = 16;
            break;
          }
          throw new Redirection301Exception(post.fallback_url, 'api__getNewPostViewData');
        case 16:
          return _context3.abrupt("return", post);
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function api__getNewPostViewData(_x4) {
    return _ref3.apply(this, arguments);
  };
}();